<template>
  <div id="app">
    <Header
      v-show="!renderFullScreen"
      :transparent="transparentHeader"
    />
    <main>
      <transition mode="out-in">
        <router-view/>
      </transition>
    </main>
  </div>
</template>

<script>
import Header from '@/components/molecules/Header'

export default {
  name: 'App',
  components: {
    Header
  },
  computed: {
    renderFullScreen: function() {
      return this.$route.name === 'room'
    },
    transparentHeader: function() {
      return this.$route.name === 'top'
    }
  }
}
</script>

<style lang='scss'>
@import "@/styles/app.scss";
</style>
